import { render } from "./NotificationResponseCounterAndReminder.vue?vue&type=template&id=ef1060a8&scoped=true&ts=true"
import script from "./NotificationResponseCounterAndReminder.vue?vue&type=script&lang=ts"
export * from "./NotificationResponseCounterAndReminder.vue?vue&type=script&lang=ts"

import "./NotificationResponseCounterAndReminder.vue?vue&type=style&index=0&id=ef1060a8&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1060a8"]])

export default __exports__